export { ComponenteText } from "./ComponenteText";
